import {
  getStatusProps,
  ProposalStatus,
} from "@/components/ProposalTable/proposalStatusRenderer";
import { formatErrorMessage } from "./formatErrorMessage.ts";
import { ProposalCustomStatus, ProposalCustomStatusItenStatus } from "@/models/proposal.model";

export const getProposalStatusAndCustomStatus = (
  status: ProposalStatus,
  customStatus: string | null | undefined
): string => {
  let proposalCustomStatus: ProposalCustomStatus | null = null;

  try {
    proposalCustomStatus = customStatus ? JSON.parse(customStatus as any) : null;
    console.log("proposalCustomStatus", proposalCustomStatus)
  } catch (error) {
    console.warn("Erro ao fazer parse do customStatus:", error, customStatus);
    proposalCustomStatus = null;
  }

  if (status === ProposalStatus.PENDING_USER_REVIEW && proposalCustomStatus?.confirmacao.criacao_proposta_bancarizadora.status === ProposalCustomStatusItenStatus.SUCESSO && proposalCustomStatus?.confirmacao.criacao_processo_seg_identidade.status === ProposalCustomStatusItenStatus.SUCESSO) {
    return "Corrigir Dados Bancários";
  }

  if (
    status === ProposalStatus.PENDING_BANK_ANALYSIS &&
    proposalCustomStatus?.acoes?.analisar_proposta_banco?.status ===
    ProposalCustomStatusItenStatus.AGUARDANDO
  ) {
    return formatErrorMessage(
      proposalCustomStatus?.acoes?.analisar_proposta_banco?.mensagem ?? ""
    );
  }

  const statusObj = getStatusProps(status);
  return statusObj?.text ?? "Status desconhecido";
};
